// extracted by mini-css-extract-plugin
module.exports = {"cardWithTitleWrapper":"cardWithTitle_cardWithTitleWrapper___7H7x","title":"cardWithTitle_title__bmEOf"};